import React, { useState, useEffect, useContext } from 'react';
import TitleBar from '../components/TitleBar.jsx';
import { urlValue, loadingContext, unfolder, openAlert, useTranslate } from '../lib';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import '../styles/campaign_customizable.css';
import { Alerts } from '../components/common/Alerts';
import logo1 from '../logos/ai-nesting-studio.svg';
import logo2 from '../logos/ai-nesting-studio-2.svg';
//import logo3 from '../logos/ai-nesting-studio3.svg';

const CampaignCustomizable = () => {
  const { campaign_id, campaign_name } = useParams();
  const [loading, setLoading] = useContext(loadingContext);
  const [alert, setAlert] = useState({ title: '', visible: false });
  const { t } = useTranslate();
  const logos = {
    'ai-nesting-studio.svg': logo1,
    'ai-nesting-studio-2.svg': logo2,
    //'ai-nesting-studio3.svg': logo3,
  };

  const [formData, setFormData] = useState({
    logo: 'ai-nesting-studio.svg',
    primaryButton: 'buttonE',
    secondaryButton: 'buttonF',
    tertiaryButton: 'buttonH',
    primaryColor: '#1c6fb0',
    secondaryColor: '#474746',
    textColor: '#0087ff',
    menuBackground: '#0087ff'
  });

  const getCustomization = async () => {
    try {
      setLoading(true);
      const token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token;
      const res = await axios.get(`${urlValue}/studio/campaign-interface-customizations/${campaign_id}`, {
        headers: { 'access-token': token }
      });
      if (res.data) {
        setFormData({ ...formData, ...res.data.options });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCustomization();
  }, []);

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    const id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;
    const token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token;
    setLoading(true);
    try {
      await axios.post(`${urlValue}/studio/campaign-interface-customizations`, {
        campaign_id,
        options: formData
      }, {
        headers: { user: id, 'access-token': token }
      });
      openAlert('#alert-ac', () => setAlert({ title: t('alerts.configSaved'), visible: true }), 3000, () => setAlert({ visible: false }));
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='general-container'>
      <TitleBar />
      <div className='primary-container d-flex flex-row flex-wrap justify-content-between mt-3'>
        <h1 style={{ fontSize: 14, textTransform: 'uppercase' }}>{campaign_name} {t('common.customization')}</h1>
        <div className='border p-2'>
          <h2 style={{ fontSize: 14, fontWeight: 'bold' }}>{t('common.interface')}</h2>
          <form onSubmit={handleSubmit} className='d-flex flex-row flex-wrap'>

            {/* Logo */}
            <div className='items-little m-2'>
              <div className='input-container'>
                <label>{t('common.logo')}:</label>
                <select name="logo" value={formData.logo} onChange={handleChange}>
                  <option value="ai-nesting-studio.svg">{t('common.logo')} 1</option>
                  <option value="ai-nesting-studio-2.svg">{t('common.logo')} 2</option>
                  {/*<option value="ai-nesting-studio3.svg">Logo 3</option>*/}
                </select>
                <div style={{ marginTop: 10 }}>
                  <img src={logos[formData.logo]} alt="Preview Logo" style={{ height: 40 }} />
                </div>
              </div>
            </div>

            {/* Botones */}
            <div className='items-little m-2'>
              <div className='input-container'>
                <label>{t('menu.primaryButton')}</label>
                <select name="primaryButton" value={formData.primaryButton} onChange={handleChange}>
                  <option value="buttonE">{t('common.style')} 1</option>
                  <option value="buttonF">{t('common.style')} 2</option>
                  <option value="buttonH">{t('common.style')} 3</option>
                </select>
                <button onClick={(e)=>{e.preventDefault();}} className={`mt-2 ${formData.primaryButton}`} 
                  style={{ padding: 5, display: 'inline-block', maxWidth: 150 }}>
                  <span>{t('menu.previewButton')}</span>
                </button>
              </div>
            </div>

            <div className='items-little m-2'>
              <div className='input-container'>
                <label>{t('menu.secodaryButton')}</label>
                <select name="secondaryButton" value={formData.secondaryButton} onChange={handleChange}>
                  <option value="buttonF">{t('common.style')} 2</option>
                  <option value="buttonE">{t('common.style')} 1</option>
                  <option value="buttonH">{t('common.style')} 3</option>
                </select>
                <button onClick={(e)=>{e.preventDefault();}} className={`mt-2 ${formData.secondaryButton}`} 
                  style={{ padding: 5, display: 'inline-block', maxWidth: 150 }}>
                  <span>{t('menu.previewButton')}</span>
                </button>
              </div>
            </div>

            <div className='items-little m-2'>
              <div className='input-container'>
                <label>{t('menu.tertiaryButton')}</label>
                <select name="tertiaryButton" value={formData.tertiaryButton} onChange={handleChange}>
                  <option value="buttonH">{t('common.style')} 3</option>
                  <option value="buttonF">{t('common.style')} 1</option>
                  <option value="buttonE">{t('common.style')} 2</option>
                </select>
                <button onClick={(e)=>{e.preventDefault();}} className={`mt-2 ${formData.tertiaryButton}`} 
                  style={{ padding: 5, display: 'inline-block', maxWidth: 150 }}>
                  <span>{t('menu.previewButton')}</span>
                </button>
              </div>
            </div>

            {/* Colores */}
            <div className='items-little m-2'>
              <div className='input-container'>
                <label>{t('menu.primaryColor')}</label>
                <input type="color" name="primaryColor" value={formData.primaryColor} onChange={handleChange} />
              </div>
            </div>

            <div className='items-little m-2'>
              <div className='input-container'>
                <label>{t('menu.secodaryColor')}</label>
                <input type="color" name="secondaryColor" value={formData.secondaryColor} onChange={handleChange} />
              </div>
            </div>

            <div className='items-little m-2'>
              <div className='input-container'>
                <label>{t('menu.tertiaryColor')}</label>
                <input type="color" name="textColor" value={formData.textColor} onChange={handleChange} />
              </div>
            </div>

            <div className='items-little m-2'>
              <div className='input-container'>
                <label>{t('menu.sidebarBackground')}</label>
                <input type="color" name="menuBackground" value={formData.menuBackground} onChange={handleChange} />
              </div>
            </div>

            <div className='w-100' style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', marginTop: 10 }}>
              <button type="submit" className='buttonE'>
                <span>{t('menu.saveCustomization')}</span>
              </button>
            </div>

          </form>
        </div>
      </div>
      {alert.visible && <Alerts id="alert-ac" title={alert.title} />}
    </div>
  );
};

export default CampaignCustomizable;
